@if (showSpinner) {
  <app-loader> </app-loader>
}
<div class="main-wrapper">
  <div class="outer-wrapper">
    <div class="inner-section-announcement">
      <div class="inner-wrapper">
        <div class="announcement-top">
          <p class="heading-announcement">Add Announcement</p>

          <div class="wrap-title-category">
            <input class="title-input" type="text" id="id" [(ngModel)]="id" hidden />
            <div class="left-title">
              <label for="title" class="search-label">Title</label>
              <input class="title-input" type="text" id="title" placeholder="Enter title of announcement"
                [(ngModel)]="title" />
              </div>
              <div class="right-category">
                <label for="category" class="search-label">Category</label>
                <!-- <select class="select-category" [(ngModel)]="selectedCategory" (change)="onCategoryChange($event)">
                <option value="selectCategory" disabled>Select category</option>
                <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
                <option value="add">Add Category</option>
              </select> -->
              <div class="custom-dropdown" (clickOutside)="closeDropdown()">
                <div class="select-category" (click)="toggleDropdown()">
                  {{ selectedCategory || 'Select category' }}
                  <span class="arrow">&#9662;</span>
                </div>

                @if (dropdownOpen) {
                  <div class="dropdown-list">
                    @for (category of categories; track category) {
                      <div class="dropdown-item" (click)="selectCategory(category)">
                        {{ category }}
                      </div>
                    }
                    <div class="dropdown-item add-category" (click)="openAddCategoryModal()">
                      <img class="plus-icon" src="../../../assets/announcement/addCategory.svg" /> Add new category
                    </div>
                  </div>
                }
              </div>


            </div>
          </div>

          <div class="wrap-status ">
            <label for="status" class="search-label">Status</label>
            <div class="radio-btns">
              <div class="left-scheduled">
                <input class="status" type="radio" name="status" placeholder="Enter title of announcement"
                  [checked]="status === 'scheduled'" (change)="setStatus('scheduled')" />
                  <span class="lbl-schedule-publish">Scheduled</span>
                </div>
                <div class="right-published">
                  <input class="status" type="radio" name="status" placeholder="Enter title of announcement"
                    [checked]="status === 'published'" (change)="setStatus('published')" />
                    <span class="lbl-schedule-publish">Published now</span>
                  </div>
                </div>
              </div>

              @if (status === 'scheduled') {
                <div class="wrap-title-category">
                  <div class="left-title">
                    <label for="title" class="search-label">Scheduled Time</label>
                    <input class="scheduled time" type="time" [(ngModel)]="start_time" />
                  </div>
                  <div class="right-category">
                    <label for="category" class="search-label">Scheduled Date</label>
                    <input class="scheduled date" type="date" [(ngModel)]="start_date" />
                  </div>
                </div>
              }


              <div class="wrap-expiary">
                <label for="expiry" class="search-label">Expiry Date</label>

                <!-- Display field with formatted date -->
                <input class="select-expiary-date" [value]="expiry_date ? (expiry_date | date:'dd MMM yyyy') : ''" readonly
                  (click)="openDatePicker()" />

                  <!-- Real date input, invisible but focusable -->
                  <input #hiddenDate type="date" [(ngModel)]="expiry_date" (change)="onDateChange($event)"
                    class="hidden-date-input" />
                  </div>

                  <div class="upload-container">
                    <label class="search-label">Upload file
                      <label class="info-label">
                        <img src="../../../assets/theme1/info-circle.svg" alt="missing" data-toggle="tooltip"
                          data-placement="top"
                          title="Select only these formats 'jpg', 'jpeg', 'png', 'gif', 'mp4', 'mov', 'avi'" />
                        </label>
                      </label>

                      <div class="images-container">
                        @if (filePreviewUrls.length === 0) {
                          <div class="drop-zone" (dragover)="onDragOver($event)"
                            (drop)="onDrop($event)" (dragleave)="onDragLeave($event)">
                            <input type="file" id="fileInput" hidden (change)="onFileSelected($event)" accept="image/*,video/*"
                              multiple />
                              <div class="upload-content" (click)="triggerFileInput()">
                                <img src="../../../assets/announcement/upload-icon.svg" alt="Upload Icon" class="upload-icon" />
                                @if (filePreviewUrls.length === 0) {
                                  <p>
                                    Drag & Drop or
                                    <span class="choose-file">Choose file</span>
                                    to upload
                                  </p>
                                }
                              </div>
                            </div>
                          }

                          @if (filePreviewUrls.length > 0) {
                            <div class="preview-container">
                              @for (file of filePreviewUrls; track file; let i = $index) {
                                <div class="preview-item">
                                  <button (click)="removeFile(i)" class="close-btn"><img class="close-btn-close-img"
                                  src="../../../assets/announcement/xx.svg"></button>
                                  @if (file.type === 'image') {
                                    <img [src]="file.url" alt="Image" class="preview-media" />
                                  }
                                  @if (file.type === 'video') {
                                    <video [src]="file.url" controls class="preview-media"></video>
                                  }
                                </div>
                              }
                              @if (filePreviewUrls.length > 0) {
                                <div class="new-drop" (dragover)="onDragOver($event)"
                                  (drop)="onDrop($event)" (dragleave)="onDragLeave($event)">
                                  <input type="file" id="fileInput" hidden (change)="onFileSelected($event)" accept="image/*,video/*"
                                    multiple />
                                    <div class="upload-content" (click)="triggerFileInput()">
                                      <img src="../../../assets/announcement/upload-icon.svg" alt="Upload Icon" class="upload-icon" />
                                    </div>
                                  </div>
                                }
                              </div>
                            }


                          </div>






                        </div>


                        <div class="description-container">
                          <label for="description" class="search-label">Description</label>
                          <ckeditor [editor]="Editor" [(ngModel)]="description" name="description" #descriptionModel="ngModel"
                            required>
                          </ckeditor>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>



                <div class="modal fade" id="addCategoryModal" tabindex="-1" role="dialog" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered centerModal" role="document">
                    <div class="modal-content container-category">

                      <!-- Modal Heading -->
                      <h2 class="heading-addCategory">Add Category</h2>

                      <!-- Input Field -->
                      <input type="text" [(ngModel)]="newCategory" class="form-control mb-3 mt-3 title-input"
                        placeholder="Enter new category" />

                        <!-- Buttons -->
                        <div class="categoryModal-footer">
                          <button class="cancel" (click)="closeModal()"> Close</button>
                          <button class="publish-btn" (click)="addCategory()"> Add</button>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="footer-container">
                    <div class="btn-float-right">
                      <button class="cancel" (click)="gotoAnnouncementManagement()"> Cancel</button>
                      <button class="publish-btn" (click)="publishAnnouncement()"> Publish</button>

                    </div>
                  </div>



                </div>